import { render } from "./GoalDueDateActivity.vue?vue&type=template&id=4a451803"
import script from "./GoalDueDateActivity.vue?vue&type=script&lang=js"
export * from "./GoalDueDateActivity.vue?vue&type=script&lang=js"
script.render = render

export default script